import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { filter, switchMap, take, takeWhile } from 'rxjs';

import { AsyncJobSelectors, AsyncJobStatus } from '@core/async-job-data';
import { filterBoolean } from '@core/common-legacy';

import { CandidateBulkSelectors } from './bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class CandidateBulkActionsService {
  private readonly store = inject(Store);

  public trackByCorrelationId(correlationId: string) {
    return this.store.select(CandidateBulkSelectors.byId(correlationId)).pipe(
      filterBoolean,
      filter(entity => !!entity.uuid),
      take(1),
      switchMap(({ uuid }) => this.store.select(AsyncJobSelectors.byId(uuid))),
      filterBoolean,
      takeWhile(job => job.status !== AsyncJobStatus.FINISHED, true),
    );
  }
}
